import { render, staticRenderFns } from "./cod-payment-settle.vue?vue&type=template&id=559551ff"
import script from "./cod-payment-settle.vue?vue&type=script&lang=js"
export * from "./cod-payment-settle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports